import ProductsList from "../../containers/ProductsList";
import Sidebar from "../../components/Sidebar";

import "./style.scss";

export default function Dashboard() {
  return (
    <>
      <Sidebar />
      <main className="component-dashboard p-xl">
        <ProductsList></ProductsList>
      </main>
    </>
  );
}